import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterOutlet } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';
import { DialogService } from 'app/services/dialog/dialog.service';
import { LoginService } from 'app/services/login/login.service';
import { ComponenteNotificacoesComponent } from "../componente-notificacoes/componente-notificacoes.component";
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SidebarComponent, MatButtonModule, RouterOutlet, ComponenteNotificacoesComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  public sessaoExpirada: boolean = false;
  public ignorarMensagemRenovarToken: boolean = false;
  form!: FormGroup;
  token: string = localStorage.getItem('token')!;

  constructor(
    public loginService: LoginService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    private transloco: TranslocoService
  ) {
    this.iniciarObservadorFimSessao();
    this.iniciarObservadorSessaoEncerrada();
  }

  ngOnInit(): void {
    this.loginService.alertaSessaoService();
  }

  public iniciarObservadorFimSessao(): void {
    this.loginService.observarFimSessao().subscribe((resp: any) => {
      if (resp) {
        if (!this.sessaoExpirada && !this.ignorarMensagemRenovarToken) {
          this.sessaoExpirada = resp;
          this.confirmarRenovacaoSessao();
        }
      } else {
        this.sessaoExpirada = false;
      }
    });
  }

  public iniciarObservadorSessaoEncerrada(): void {
    this.loginService.observarSessaoEncerrada().subscribe((resp: any) => {
      if (resp) {
        this.modalLogin();
      }
    });
  }

  public async confirmarRenovacaoSessao(): Promise<void> {
    const expirationTime = localStorage.getItem('expira_token');

    if (!this.token) {
      this.dialogService.erro(
        this.transloco.translate('COMPONENTS.HOME.ERROR.TITLE'),
        this.transloco.translate('COMPONENTS.HOME.ERROR.TOKEN_NOT_FOUND')
      );
      setTimeout(() => {
        window.location.href = this.loginService.baseUrlPremocenterFront;
      }, 3000);
      return;
    }

    const confirmou = await this.dialogService.confirmacao(
      this.transloco.translate('COMPONENTS.HOME.SESSION.RENEW_QUESTION'),
      this.transloco.translate('COMPONENTS.HOME.SESSION.EXPIRES_AT', { expirationTime }),
      this.transloco.translate('COMPONENTS.HOME.BUTTONS.YES'),
      this.transloco.translate('COMPONENTS.HOME.BUTTONS.NO'),
      false
    );

    if (confirmou) {
      this.dialogService.loading(
        this.transloco.translate('COMPONENTS.HOME.SESSION.RENEW_LOADING')
      );
      this.loginService.renovarToken(this.token).subscribe({
        next: (resp: any) => {
          this.dialogService.fechar();

          if (resp && resp.access_token) {
            this.loginService.atualizarToken(resp.access_token);
            this.token = resp.access_token;
            this.sessaoExpirada = false;
            this.dialogService.sucesso(
              this.transloco.translate('COMPONENTS.HOME.SESSION.RENEW_SUCCESS_TITLE'),
              this.transloco.translate('COMPONENTS.HOME.SESSION.RENEW_SUCCESS_MESSAGE')
            );
          } else {
            this.dialogService.erro(
              this.transloco.translate('COMPONENTS.HOME.ERROR.TITLE'),
              this.transloco.translate('COMPONENTS.HOME.ERROR.RENEW_INVALID_RESPONSE')
            );
          }
        },
        error: () => {
          this.dialogService.erro(
            this.transloco.translate('COMPONENTS.HOME.ERROR.TITLE'),
            this.transloco.translate('COMPONENTS.HOME.ERROR.RENEW_SESSION_ERROR')
          );
          setTimeout(() => {
            window.location.href = this.loginService.baseUrlPremocenterFront;
          }, 3000);
        },
      });
    } else {
      this.sessaoExpirada = false;
      this.ignorarMensagemRenovarToken = true;
    }
  }

  public async modalLogin(): Promise<void> {
    if (this.token) {
      const decoded: any = jwtDecode(this.token);
      const vc_login = decoded.login;

      const password = await this.dialogService.solicitarSenha(vc_login);
      if (password) {
        this.form = this.formBuilder.group({
          vc_login: new FormControl('', [Validators.required]),
          vc_senha: new FormControl('', [Validators.required])
        });

        this.form.get('vc_login')?.setValue(vc_login);
        this.form.get('vc_senha')?.setValue(password);

        this.loginService.reconectar(this.form.value).subscribe(
          (resp: any) => {
            this.loginService.atualizarToken(resp.token);
            this.token = resp.token;
            this.dialogService.sucesso(
              this.transloco.translate('COMPONENTS.HOME.SESSION.RENEW_SUCCESS_TITLE'),
              this.transloco.translate('COMPONENTS.HOME.SESSION.RENEW_SUCCESS_MESSAGE')
            );
          },
          () => {
            this.dialogService.erro(
              this.transloco.translate('COMPONENTS.HOME.ERROR.TITLE'),
              this.transloco.translate('COMPONENTS.HOME.ERROR.RENEW_SESSION_ERROR')
            );
            setTimeout(() => {
              window.location.href = this.loginService.baseUrlPremocenterFront;
            }, 3000);
          }
        );
      }
    }
  }
}